const form = document.querySelector("#newsletter-form");

if (form) {
  form.addEventListener("submit", (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const data = Object.fromEntries(formData);
    console.log("🚀 ~ data:", data);

    if (!data.email) {
      document.querySelector("#newsletter-email").style.border = "1px solid red";
      return;
    }

    //TODO: send to email provider
    document.querySelector("#newsletter-content").style.display = "none";
    document.querySelector("#newsletter-success").style.display = "flex";
  });
}
